import React from "react";
import { IconType } from "react-icons";
import Loading from "../common/Loading";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} arrow />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#007bff",
    color: "#fff",
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#007bff",
  },
}));

interface BlueButtonProps {
  label: string;
  height?: string;
  width?: string;
  icon?: IconType | string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  isCommingSoon?: boolean;
  testId?: string;
  comingsoonText?: string;
  imgAlt?: string;
}

const BlueButton: React.FC<BlueButtonProps> = ({
  isCommingSoon,
  comingsoonText,
  loading,
  onClick,
  label,
  height,
  width,
  icon,
  className,
  disabled,
  testId,
  imgAlt = "icon",
}) => {
  const buttonStyle = {
    height: height || "auto",
    width: width || "auto",
    padding: width ? "10px" : "",
    gap: width ? "5px" : "10px",
    fontSize: width ? "14px" : "15px",
  };

  const renderIcon = () => {
    if (typeof icon === "string") {
      return <img src={icon} alt={imgAlt} className="w-5 h-5 object-contain" />;
    }
    if (icon) {
      const IconComponent = icon;
      return <IconComponent style={{ strokeWidth: "1.5px" }} size={20} />;
    }
    return null;
  };

  const buttonElement = (
    <button
      data-testid={testId}
      disabled={disabled || loading}
      onClick={onClick}
      className={className ? "generate-btn " + className : "generate-btn "}
      style={buttonStyle}
    >
      {renderIcon()}
      {loading && <Loading />}
      <span>{label}</span>
    </button>
  );

  if (isCommingSoon) {
    return (
      <LightTooltip title={comingsoonText || "Coming Soon!"}>
        {buttonElement}
      </LightTooltip>
    );
  }

  return buttonElement;
};

export default BlueButton;
